webpackJsonp([23963433712142],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InstagramDisplay = function (_React$Component) {
	  _inherits(InstagramDisplay, _React$Component);
	
	  function InstagramDisplay() {
	    _classCallCheck(this, InstagramDisplay);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  InstagramDisplay.prototype.render = function render() {
	    var imageURLs = this.props.imageURLs;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "instagram-container" },
	      _react2.default.createElement(
	        "div",
	        null,
	        "FOLLOW US ON INSTAGRAM"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        "@whole_sol"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        imageURLs.map(function (url) {
	          return _react2.default.createElement("div", {
	            className: "instagram-display-image",
	            key: url,
	            style: { backgroundImage: "url(" + url + ")" }
	          });
	        })
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: _config.socialMediaConfig.instagram.link,
	          target: "_blank",
	          rel: "noopener"
	        },
	        _react2.default.createElement(
	          "button",
	          null,
	          "SEE MORE +"
	        )
	      )
	    );
	  };
	
	  return InstagramDisplay;
	}(_react2.default.Component);
	
	exports.default = InstagramDisplay;
	
	
	InstagramDisplay.propTypes = {
	  imageURLs: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
	};
	module.exports = exports["default"];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _InstagramDisplay = __webpack_require__(155);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InstagramDisplay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InstagramQuery = function (_React$Component) {
	  _inherits(InstagramQuery, _React$Component);
	
	  function InstagramQuery() {
	    _classCallCheck(this, InstagramQuery);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = { imageURLs: [] };
	    return _this;
	  }
	
	  InstagramQuery.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    window.fbLoaded.promise.then(function () {
	      FB.api("/" + ("17841406065876864"), "get", {
	        fields: "media.limit(10){media_url}",
	        access_token: ("EAACneeDfnzIBAMnZChIs4WcLybFK9RJkMBeugsXU9XMtJW9HAeG1Fazg4oZChWokAVVG27buRU8cjwtZCtRuvQ3ir7WapFgmZCoKRmufcKVwDBZCeYNRQkNwHxpma4ZBGcMT93CIcdwMyU2jZBvYR5JZA0wajfxqawu3DalfJcattQZDZD")
	      }, function (resp) {
	        var res = [];
	        resp.media.data.forEach(function (e) {
	          return res.push(e.media_url);
	        });
	        _this2.setState({ imageURLs: res });
	      });
	    });
	  };
	
	  InstagramQuery.prototype.render = function render() {
	    return this.props.children(this.state.imageURLs);
	  };
	
	  return InstagramQuery;
	}(_react2.default.Component);
	
	exports.default = InstagramQuery;
	module.exports = exports["default"];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _InstagramQuery = __webpack_require__(157);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InstagramQuery).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(94);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _fishrmnComponents = __webpack_require__(29);
	
	var _fishrmnTypes = __webpack_require__(43);
	
	var _config = __webpack_require__(30);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _InstagramDisplay = __webpack_require__(156);
	
	var _InstagramDisplay2 = _interopRequireDefault(_InstagramDisplay);
	
	var _InstagramQuery = __webpack_require__(158);
	
	var _InstagramQuery2 = _interopRequireDefault(_InstagramQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locationInfo = [{
	  city: "Denver - LoDo/Union Station",
	  address: "1735 Chestnut Place, Denver, CO 80202",
	  hours: ["Monday - Friday: 7am - 6pm", "Saturday - Sunday: 7:30am - 6pm"],
	  phone: "(720) 372-7862",
	  orderOnlineLink: "https://www.ubereats.com/store/whole-sol-blend-bar-lodo/WaRh1OevS964-f_mkBHHeA?pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkRlbnZlciUyMFVuaW9uJTIwU3RhdGlvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMjZmYzc4NzAwLTM0Y2QtM2IyOS05MDRlLWM5MmMxNzBiODRkYSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJ1YmVyX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBMzkuNzUzMTQyOSUyQyUyMmxvbmdpdHVkZSUyMiUzQS0xMDUuMDAwMTUzOSU3RA%3D%3D"
	}, {
	  city: "Boulder - Twenty Ninth Street Mall",
	  address: "1810 29th St #1087, Boulder, CO 80301",
	  hours: ["Monday - Thursday: 8am - 6pm", "Friday - Sunday: 7am - 7pm"],
	  phone: "(303) 209-7477",
	  orderOnlineLink: "https://www.ubereats.com/store/whole-sol-blend-bar-twenty-ninth-street/-VJ_LcUPSXW0kAlLaFi3Gg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkRlbnZlciUyMFVuaW9uJTIwU3RhdGlvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMjZmYzc4NzAwLTM0Y2QtM2IyOS05MDRlLWM5MmMxNzBiODRkYSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJ1YmVyX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBMzkuNzUzMTQyOSUyQyUyMmxvbmdpdHVkZSUyMiUzQS0xMDUuMDAwMTUzOSU3RA%3D%3D"
	}, {
	  city: "Denver - Tabor Center - Now Open!",
	  address: "1200 17th St Suite 150, Denver, CO 80202",
	  hours: ["Monday - Friday 7am - 3pm"],
	  phone: "303-954-9419",
	  orderOnlineLink: "https://www.ubereats.com/store/whole-sol-blend-bar-tabor-center/_znCwUyaWdaxZIEY5LNCLA?diningMode=DELIVERY"
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { id: "locations" },
	    _react2.default.createElement(_fishrmnComponents.SEO, {
	      config: _config2.default,
	      path: _config2.default.baseConfig.pageMetadata.locations.path,
	      title: _config2.default.baseConfig.pageMetadata.locations.title,
	      description: _config2.default.baseConfig.pageMetadata.locations.description,
	      smTypes: [_fishrmnTypes.socialMediaTypes.facebook, _fishrmnTypes.socialMediaTypes.twitter]
	    }),
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify({
	          "@context": "https://schema.org/",
	          "@type": "LocalBusiness",
	          name: "Whole Sol",
	          aggregateRating: {
	            "@type": "AggregateRating",
	            ratingValue: "4.7",
	            ratingCount: "106"
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "locations-background" },
	      _react2.default.createElement(
	        "div",
	        { id: "locations-overlay" },
	        _react2.default.createElement(
	          "h1",
	          { id: "locations-title" },
	          "WHOLE SOL LOCATIONS"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "location-info" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.google.com/maps/place/1735+Chestnut+Pl,+Denver,+CO+80202/@39.7556528,-105.0041489,17z/data=!3m1!4b1!4m5!3m4!1s0x876c78c26b8442d7:0xd2927d3cd07eee5!8m2!3d39.7556528!4d-105.0019602",
	                target: "_blank",
	                rel: "noopener"
	              },
	              _react2.default.createElement(
	                "h2",
	                null,
	                locationInfo[0].city
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                locationInfo[0].address
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "tel:" + locationInfo[0].phone },
	              _react2.default.createElement(
	                "h3",
	                null,
	                locationInfo[0].phone
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "Hours"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                locationInfo[0].hours.map(function (hourItem) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: hourItem },
	                    hourItem
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { id: "locations-buttons-container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: locationInfo[0].orderOnlineLink,
	                    target: "_blank",
	                    rel: "noopener"
	                  },
	                  _react2.default.createElement(
	                    "button",
	                    { id: "online-order-button" },
	                    "ORDER DELIVERY"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { id: "online-order-button-desc" },
	                    "Delivery provided by Uber Eats, Whole Sol's exclusive delivery partner.",
	                    " "
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "location-info" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.google.com/maps/place/3605+Walnut+St,+Denver,+CO+80205/@39.7689823,-104.9765406,17z/data=!3m1!4b1!4m6!3m5!1s0x876c791aa0734f4b:0x356f36fab6d5e6ff!8m2!3d39.7689782!4d-104.9739603!16s%2Fg%2F11ljb0xbg4?entry=ttu",
	                target: "_blank",
	                rel: "noopener"
	              },
	              _react2.default.createElement(
	                "h2",
	                null,
	                locationInfo[1].city
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                locationInfo[1].address
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "tel:" + locationInfo[1].phone },
	              _react2.default.createElement(
	                "h3",
	                null,
	                locationInfo[1].phone
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "Hours"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                locationInfo[1].hours.map(function (hourItem) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: hourItem },
	                    hourItem
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { id: "locations-buttons-container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: locationInfo[1].orderOnlineLink,
	                    target: "_blank",
	                    rel: "noopener"
	                  },
	                  _react2.default.createElement(
	                    "button",
	                    { id: "online-order-button" },
	                    "ORDER DELIVERY"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { id: "online-order-button-desc" },
	                    "Delivery provided by Uber Eats, Whole Sol's exclusive delivery partner.",
	                    " "
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "location-info" },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.google.com/maps/place/Tabor+Center/@39.7488148,-104.9965355,15z/data=!4m2!3m1!1s0x0:0x2b4a50db8be673de?sa=X&ved=2ahUKEwjlvKrN5uj7AhVhhXIEHVqmAGIQ_BJ6BAhlEAg",
	                target: "_blank"
	              },
	              _react2.default.createElement(
	                "h2",
	                null,
	                locationInfo[2].city
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                locationInfo[2].address
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "tel:" + locationInfo[2].phone },
	              _react2.default.createElement(
	                "h3",
	                null,
	                locationInfo[2].phone
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "Hours"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                locationInfo[2].hours.map(function (hourItem) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: hourItem },
	                    hourItem
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { id: "locations-buttons-container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: locationInfo[2].orderOnlineLink,
	                    target: "_blank",
	                    rel: "noopener"
	                  },
	                  _react2.default.createElement(
	                    "button",
	                    { id: "online-order-button" },
	                    "ORDER DELIVERY"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { id: "online-order-button-desc" },
	                    "Delivery provided by Uber Eats, Whole Sol's exclusive delivery partner.",
	                    " "
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _InstagramQuery2.default,
	        null,
	        function (imageURLs) {
	          return _react2.default.createElement(_InstagramDisplay2.default, { imageURLs: imageURLs });
	        }
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-locations-jsx-645f36ac9187c4e7f707.js